import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Alert from "../../Components/alert/Alert";
import {handleColor} from '../../services/Functions'
import ReportDepartaments from "../Reports/reportDepartaments";
import AddUser from "../Registration/Users/addUser";
import AltUser from "../Registration/Users/altUser";
import DelUser from "../Registration/Users/delUser";
import Users from "../Reports/reportUsers";
import UserAlterPassword from "../User/userAlterPassword";
import UserPreference from "../User/userPreference";
import {Redirect} from "react-router-dom";
import "./prelude.css";

class PreludeUserPreferences extends React.Component {
  render() {
    return (
      <>
        <header>
          <Top_bar />{" "}
        </header>
        <div className="prelude_container">
          <Sidebar></Sidebar>
        </div>
        <BottomBar></BottomBar>
      </>
    );
  }
}

class Sidebar extends React.Component {
  state = { render: false, message: "", click: false, users: false };

  async componentWillMount() {
      let viewport = document.querySelector("meta[name=viewport]");
      viewport.setAttribute("content", viewport.content + ", height=" + window.innerHeight);
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  usersClick = ()=>{
    this.setState({users: true});
  }

  render() {
    const { show, message, users } = this.state;
    let admin = localStorage.getItem("@oee-monitor/admin");
    return (
      <Tab.Container defaultActiveKey="infos">
        <Row style={{width:'100%',height:'100%'}}>
          <div className="sidebar1 ">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    style={{
                      backgroundColor: "#05ca83",
                      color: "#fff",
                      border: "none",
                    }}
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    eventKey="infos"
                  >
                    Dados Pessoais
                  </ListGroup.Item>
                  {(admin == 1) ? (<ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg2"
                    onClick={this.usersClick}
                    className="listGroup"
                    action
                    eventKey="users"
                  >
                    Usuários
                  </ListGroup.Item>):(null)}
                  
                </ListGroup>
              </Col>
            </div>
            <Col className='col3' style={{ top: "5%", marginLeft: "1.5%", height:'78vh' ,width: "100%", overflow:'auto' }}>
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane eventKey="users">
                  {(users == true ? (<Redirect to={{ pathname: "/usuarios"}}></Redirect>) : null)}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="infos">
                  {this.handleClick ? <UserPreference></UserPreference> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default PreludeUserPreferences;